module.exports = __webpack_public_path__ + "static/media/veladat-dark.e14dabf8.png";